var map = {
	"./de/triangle-icon.png": "AlFO",
	"./en/triangle-icon.png": "i8k7",
	"./es/triangle-icon.png": "64bb",
	"./fr/triangle-icon.png": "MzfA",
	"./ja/triangle-icon.png": "tJA7",
	"./ko/triangle-icon.png": "Oo5O",
	"./pt/triangle-icon.png": "K+dw",
	"./ru/triangle-icon.png": "oulO",
	"./tc/triangle-icon.png": "1QZu",
	"./th/triangle-icon.png": "WvTt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oT2C";